import React from "react";
import { Modal, Button } from "semantic-ui-react";
import { useIntl } from "react-intl";
import { FormAssessmentType } from "./sequence/Assessment";

// Types
type ModSaveAssessmentProps = {
  // data
  open: boolean;
  type: FormAssessmentType;
  // config
  isSaveReassessment?: boolean;
  // callback
  onSave?: (params: {
    sequence: string;
    card: string;
    action: "SAVE";
    status: "CONFIRM" | "SAVE";
    isSaveReassessment?: boolean;
    type: FormAssessmentType;
  }) => any;
  onClose?: () => any;
};
const ModSaveAssessment = (props: ModSaveAssessmentProps) => {
  const intl = useIntl();
  const handleSaveConfirm = () => {
    props.onSave?.({
      sequence: "Assessment",
      card: "CardAssessment",
      action: "SAVE",
      status: "CONFIRM",
      type: props.type,
      isSaveReassessment: props.isSaveReassessment,
    });
  };

  const handleSaveDraft = () => {
    props.onSave?.({
      sequence: "Assessment",
      card: "CardAssessment",
      action: "SAVE",
      status: "SAVE",
      type: props.type,
      isSaveReassessment: props.isSaveReassessment,
    });
  };

  return (
    <Modal id="ModSaveAssessment-Modal" onClose={props.onClose} open={props.open} size="mini">
      <Modal.Header style={{ backgroundColor: "#2d9cdb", color: "#ffffff" }}>
        ต้องการยืนยันเอกสารใช่หรือไม่
      </Modal.Header>
      <Modal.Content>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <div>
            <Button id="ModSaveAssessment-Button-Confirm" basic color="green" onClick={handleSaveConfirm}>
              Confirm
            </Button>
          </div>
          <div>
            <Button id="ModSaveAssessment-Button-Draft" basic color="teal" onClick={handleSaveDraft}>
              Save draft
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default React.memo(ModSaveAssessment);
